/**
 * Nội dung tệp hướng dẫn tải về từ màn Kho dữ liệu.
 *
 * Để ở dạng dữ liệu trong repo chứ không kèm một tệp `.docx` dựng sẵn: một
 * tệp nhị phân trong git thì không đọc được diff, không ai review được, và
 * người sửa màn hình sẽ quên cập nhật nó. Ở đây thì sửa hướng dẫn là một dòng
 * trong pull request.
 */

import type { Khoi } from './tao-docx.ts';

export const TEN_TEP = 'Huong-dan-khai-bao-nghiep-vu.docx';

export const HUONG_DAN: Khoi[] = [
  { loai: 'tieuDe', chu: 'Hướng dẫn khai báo nghiệp vụ', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Tài liệu này hướng dẫn các bước ở màn **Nguồn dữ liệu → Kho dữ liệu**, ' +
      'và cách điền **tệp trả lời** (.yml hoặc .md) để khai báo hàng trăm câu cùng lúc.',
  },
  {
    loai: 'doan',
    chu:
      'Vì sao phải khai báo: trợ lí sinh câu SQL từ lược đồ. Lược đồ cho biết tên cột, ' +
      'nhưng không cho biết **ý nghĩa**. Khi chưa khai báo, trợ lí vẫn trả lời — và có thể trả lời ' +
      'sai trong khi vẫn trích dẫn được tới từng ô, tức là sai theo cách rất khó phát hiện.',
  },

  { loai: 'tieuDe', chu: '1. Năm bước trên màn Kho dữ liệu', cap: 1 },
  {
    loai: 'gach',
    chu:
      '**Chọn bảng từ CSDL** — đọc cấu trúc cơ sở dữ liệu nguồn và chọn bảng cần lấy. ' +
      'Bỏ qua bảng sao lưu, bảng tạm, bảng nhật ký: các bảng này chỉ làm tăng khả năng chọn nhầm.',
  },
  {
    loai: 'gach',
    chu: '**Đồng bộ ngay** — đồng bộ dữ liệu về bản sao. Bước sau cần có dữ liệu mới phân tích được.',
  },
  {
    loai: 'gach',
    chu:
      '**Dò mã & quan hệ** — hệ thống tự tìm cột mã trạng thái, quan hệ ngầm giữa các ' +
      'bảng, và bảng không còn dùng. Kết quả là đề xuất, cần được duyệt từng mục.',
  },
  {
    loai: 'gach',
    chu:
      '**Khai báo nghiệp vụ** — trả lời các câu hỏi còn trống. Câu hỏi được xếp theo mức thiệt hại khi ' +
      'thiếu, không theo thứ tự cột: làm lần lượt từ trên xuống là đúng thứ tự ưu tiên.',
  },
  {
    loai: 'gach',
    chu: '**Nghiệp vụ đã khai báo** — xem lại và sửa những nội dung đã khai báo. Khai báo sai vẫn sửa được bất cứ lúc nào.',
  },

  { loai: 'tieuDe', chu: '2. Ba mức thiệt hại', cap: 1 },
  {
    loai: 'doan',
    chu: 'Màn Khai báo nghiệp vụ lọc câu theo ba mức. Hiểu đúng ba mức này sẽ biết nên làm phần nào trước.',
  },
  {
    loai: 'gach',
    chu:
      '**Trả lời sai mà không ai biết** — nặng nhất. Câu trả lời vẫn được đưa ra, vẫn trích dẫn được ' +
      'tới từng ô, nhưng sai. Ví dụ: chưa khai báo một dòng là gì thì "top 3 khách hàng" trả về ' +
      'ba hoá đơn. Ưu tiên xử lý nhóm này trước.',
  },
  {
    loai: 'gach',
    chu:
      '**Bị từ chối, người dùng thấy** — câu hỏi không chạy được và màn hình nêu rõ lý do. ' +
      'Gây bất tiện nhưng không nguy hiểm: người dùng biết là chưa có câu trả lời.',
  },
  {
    loai: 'gach',
    chu: '**Chỉ khó đọc** — câu trả lời đúng, chỉ là hiển thị tên cột thay vì tên nghiệp vụ.',
  },

  { loai: 'tieuDe', chu: '3. Tệp trả lời', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Màn Khai báo nghiệp vụ hỏi từng câu một. Khi có hàng trăm câu, hoặc người nắm ' +
      'câu trả lời làm việc ở bộ phận khác, dùng **tệp trả lời**: xuất bộ câu hỏi ra tệp, điền, ' +
      'rồi tải lên lại.',
  },
  {
    loai: 'doan',
    chu:
      '**Chỉ nhận đúng hai định dạng: .yml (hoặc .yaml) và .md**, viết theo mẫu ở mục 3.2. ' +
      'Word, PDF, Excel hay văn bản tự do không còn được chấp nhận. Tệp được hệ thống đọc từng dòng ' +
      'theo mã câu — không qua mô hình AI — nên xử lý xong ngay, không phát sinh chi phí, và câu ' +
      'trả lời không bao giờ bị gắn nhầm sang câu khác.',
  },

  { loai: 'tieuDe', chu: '3.1. Ba bước', cap: 2 },
  {
    loai: 'gach',
    chu:
      '**Xuất:** ở tab Khai báo nghiệp vụ bấm **Xuất N câu**. Trình duyệt tải về tệp ' +
      '`ban-khai-<nguồn>-<ngày>.yml` chứa mọi câu còn trống của nguồn, mỗi câu một dòng ' +
      '`mã câu:` để trống, câu hỏi nằm ở các dòng chú thích `#` ngay phía trên.',
  },
  {
    loai: 'gach',
    chu:
      '**Điền:** mở bằng bất kỳ trình soạn văn bản nào (Notepad, VS Code…), viết câu trả lời ' +
      'sau dấu hai chấm. Câu nào không biết thì để trống — để trống tốt hơn là đoán.',
  },
  {
    loai: 'gach',
    chu:
      '**Tải lên:** bấm **Tải tệp trả lời**, chọn tệp. Câu trả lời hiện vào từng ô dưới dạng ' +
      'đề xuất — rà soát, bấm Duyệt (hoặc Duyệt tất cả), rồi bấm **Lưu**.',
  },

  { loai: 'tieuDe', chu: '3.2. Mẫu tệp', cap: 2 },
  { loai: 'doan', chu: '**Dạng YAML (.yml) — dạng mà nút Xuất tạo ra:**' },
  {
    loai: 'ma',
    chu: [
      '# ═══ oinv — Hoá đơn bán hàng',
      '# Mỗi dòng trong bảng oinv ghi lại một cái gì?',
      'oinv.grain: Một dòng là một hoá đơn bán hàng, phân biệt theo doc_entry',
      '# Chọn một: giao_dich | anh_chup | danh_muc | khac',
      'oinv.kieu_bang: giao_dich',
      'oinv.additive.doc_total: co',
      'oinv.label.u_shd: Số hoá đơn',
      '# Nghĩa từng mã — mỗi mã một dòng, thụt vào 2 dấu cách',
      'oinv.nghia_ma.u_trang_thai:',
      '  "DPH": Đã phát hành',
      '  "CPH": Chưa phát hành',
      'oinv.thuat_ngu: "hoá đơn hợp lệ = canceled = \'N\'"',
    ].join('\n'),
  },
  { loai: 'doan', chu: '**Dạng Markdown (.md) — cùng nội dung:**' },
  {
    loai: 'ma',
    chu: [
      '## oinv — Hoá đơn bán hàng',
      '- `oinv.grain`: Một dòng là một hoá đơn bán hàng, phân biệt theo doc_entry',
      '- `oinv.kieu_bang`: giao_dich',
      '- `oinv.additive.doc_total`: co',
      '- `oinv.nghia_ma.u_trang_thai`:',
      '  - `DPH`: Đã phát hành',
      '  - `CPH`: Chưa phát hành',
    ].join('\n'),
  },
  {
    loai: 'doan',
    chu:
      'Ở dạng .md, hệ thống chỉ đọc những dòng bắt đầu bằng "- " rồi mã câu trong cặp dấu huyền, ví dụ - `oinv.grain`:. Tiêu đề, đoạn văn, ' +
      'ghi chú xen giữa đều được bỏ qua — có thể viết thêm giải thích tuỳ ý.',
  },

  { loai: 'tieuDe', chu: '3.3. Bảy loại câu và cách trả lời', cap: 2 },
  {
    loai: 'doan',
    chu: 'Mã câu có dạng `<bảng>.<loại>` hoặc `<bảng>.<loại>.<cột>`. Loại quyết định cách ghi:',
  },
  {
    loai: 'gach',
    chu:
      '**enabled** — trợ lí có được dùng bảng này không. Ghi `co` hoặc `khong`. ' +
      'Chọn `khong` cho bảng sao lưu, bảng tạm, bảng nhật ký.',
  },
  {
    loai: 'gach',
    chu:
      '**grain** — mỗi dòng của bảng ghi lại điều gì. Viết một câu ngắn: "Một dòng là một ' +
      'mặt hàng trên một hoá đơn". Đây là câu quan trọng nhất và hay bị bỏ sót nhất: thiếu nó thì ' +
      '"top 3 khách hàng" có thể trả về 3 hoá đơn.',
  },
  {
    loai: 'gach',
    chu:
      '**kieu_bang** — bảng ghi loại số liệu nào. Ghi đúng một trong: `giao_dich` (mỗi dòng ' +
      'là một việc đã xảy ra), `anh_chup` (số dư tại một thời điểm: tồn kho, số dư tài ' +
      'khoản), `danh_muc` (bảng tra: khách hàng, mặt hàng), `khac`.',
  },
  {
    loai: 'gach',
    chu:
      '**additive.<cột>** — cộng cột này qua nhiều dòng có cho ra con số có ý nghĩa không. ' +
      'Ghi `co` cho số lượng, thành tiền, số phát sinh; `khong` cho đơn giá, tỷ lệ %, ' +
      'số dư đầu/cuối kỳ, lũy kế, và mọi cột mã hay số thứ tự.',
  },
  {
    loai: 'gach',
    chu:
      '**label.<cột>** — tên nghiệp vụ thường dùng trong đơn vị, ví dụ "Số hoá đơn". ' +
      'Tên này hiển thị trong câu trả lời và biểu đồ.',
  },
  {
    loai: 'gach',
    chu:
      '**nghia_ma.<cột>** — nghĩa của từng mã trong cột. Không viết trên cùng dòng: viết ' +
      'mỗi mã một dòng thụt vào bên dưới, dạng `"mã": nghĩa`. Tệp xuất ra đã liệt kê sẵn ' +
      'các mã đo được — chỉ cần điền nghĩa; mã nào không biết thì để trống.',
  },
  {
    loai: 'gach',
    chu:
      '**thuat_ngu** — thuật ngữ nội bộ cần được diễn giải bằng một điều kiện lọc, dạng ' +
      '`từ = điều kiện`, ví dụ "khách lớn = doanh số năm trên 1 tỷ". Không có thì để trống.',
  },

  { loai: 'tieuDe', chu: '3.4. Quy tắc viết (YAML)', cap: 2 },
  {
    loai: 'gach',
    chu:
      'Mỗi câu trả lời nằm trên **một dòng**, ngay sau `mã câu:` và một dấu cách. ' +
      'Không xuống dòng giữa câu trả lời.',
  },
  {
    loai: 'gach',
    chu:
      'Câu trả lời có dấu hai chấm kèm dấu cách (": "), có dấu `#`, hoặc bắt đầu bằng ' +
      'dấu nháy thì **đặt trong nháy kép**: `oinv.grain: "Một dòng là: một hoá đơn"`. ' +
      'Bên trong nháy kép, dấu nháy kép viết là `\\"`.',
  },
  {
    loai: 'gach',
    chu:
      'Dòng bắt đầu bằng `#` là chú thích — hệ thống bỏ qua. Viết thêm ghi chú thì bắt đầu ' +
      'dòng bằng `#`. Ghi chú cuối dòng viết sau một dấu cách: `oinv.kieu_bang: giao_dich  # đã hỏi kế toán`.',
  },
  {
    loai: 'gach',
    chu:
      'Câu có danh sách lựa chọn (`co`/`khong`, `giao_dich`/…) phải ghi **đúng một giá trị** ' +
      'trong danh sách ở dòng chú thích "Chọn một". Chữ hoa hay thường đều được; ghi khác ' +
      'danh sách thì câu đó bị bỏ qua và báo lỗi.',
  },
  {
    loai: 'gach',
    chu:
      'Không đổi mã câu, không đổi thụt lề của dòng mã câu (luôn sát lề trái). Xoá bớt ' +
      'câu không cần trả lời, hoặc sao chép câu trả lời sang tệp khác, đều được.',
  },

  { loai: 'tieuDe', chu: '3.5. Khi tệp có lỗi', cap: 2 },
  {
    loai: 'doan',
    chu:
      'Hệ thống không suy đoán. Dòng sai định dạng, mã câu không còn trong danh sách câu còn trống ' +
      '(đã khai báo rồi, hoặc bảng đã bị gỡ), hay giá trị ngoài danh sách lựa chọn đều bị ' +
      'bỏ qua — các câu còn lại vẫn được nhận. Màn hình báo số câu bị bỏ qua và tự tải về tệp ' +
      '`loi-tep-tra-loi-….md` ghi đúng số dòng hoặc mã câu kèm lý do. Sửa rồi tải lên lại ' +
      'cả tệp: câu đã nhận ở lần trước không bị nhận hai lần.',
  },

  { loai: 'tieuDe', chu: '4. Vì sao vẫn phải bấm Duyệt', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Câu trả lời từ tệp chỉ là đề xuất cho tới khi có người bấm Duyệt và Lưu. ' +
      'Lý do nằm ở mức thiệt hại nặng nhất đã nêu ở mục 2: một khai báo sai khiến câu ' +
      'trả lời sai nhưng vẫn chạy bình thường, và không phép kiểm tra nào của hệ thống phát hiện được. ' +
      'Con số sai đó có thể được người dùng đưa vào báo cáo, cuộc họp.',
  },
  {
    loai: 'doan',
    chu:
      'Đề xuất chưa duyệt không được lưu lại: tải lại trang sẽ mất. ' +
      'Cần Duyệt và Lưu ngay trong phiên làm việc — tệp vẫn còn nên có thể tải lên lại.',
  },
];
